import React from 'react';
import classNames from 'classnames';

import './TagsInput.scss';

export default function TagsInput({
	placeholder,
	separators = ['Enter', ',', ' '],
	value,
	onChange,
	errors = [],
}) {
	function handleKeyDown(e) {
		if (e.code === 'Enter' || e.code === 'NumpadEnter') e.preventDefault();

		if (separators.includes(e.key)) {
			const newValue = e.target.value;
			if (!newValue.trim() || value.includes(newValue.trim())) {
				e.target.value = '';
				return;
			}
			onChange([...value, newValue]);
			e.target.value = '';
		} else if (e.key === 'Backspace' && e.target.value === '') {
			onChange(value.slice(0, -1));
		}
	}

	const handleChange = e => {
		if (separators.includes(e.target.value)) {
			e.target.value = '';
		}
	};

	const handleBlur = event => {
		handleKeyDown({ ...event, key: 'Enter' });
	};

	function removeTag(index) {
		onChange(value.filter((el, i) => i !== index));
	}

	const error = errors.filter(Boolean).reverse()[0];

	return (
		<>
			<div className="tags-input">
				{value.map((tag, index) => {
					return (
						<div
							className={classNames('tags-input__item', {
								'tags-input__item--invalid': errors[index],
							})}
							key={index}
						>
							<span className="ty-b3">{tag}</span>
							<span className="tags-input__item__close" onClick={() => removeTag(index)}>
								&times;
							</span>
						</div>
					);
				})}
				<input
					onKeyDown={handleKeyDown}
					onChange={handleChange}
					onBlur={handleBlur}
					type="text"
					className="tags-input__input ty-b2"
					placeholder={placeholder}
				/>
			</div>
			{error && <div className="tags-input-error">{error}</div>}
		</>
	);
}
